module.exports = __webpack_public_path__ + "static/media/blog1.ab4ad7da.png";